import AbstractFieldVisitor from "../metamodel/AbstractFieldVisitor";
import * as React from "react";
import IField from "../metamodel/IField";
import ArrayField from "../metamodel/Fields/ArrayField";
import EnumField from "../metamodel/Fields/EnumField";
import ImageField from "../metamodel/Fields/ImageField";
import LengthIntervalField from "../metamodel/Fields/LengthIntervalField";
import TextField from "../metamodel/Fields/TextField";
import BooleanField from "../metamodel/Fields/BooleanField";

export default class PropertyDisplayFactory extends AbstractFieldVisitor<((data: any) => React.ReactElement<any>)> {

    public build(field: IField, data: any): (data: any) => React.ReactElement<any> {
        return field.accept(this)(data[field.id]);
    }

    protected visitArrayField(field: ArrayField): (data: any) => React.ReactElement<any> {
        return (data: any) => <span>{data.join(', ')}</span>
    }

    protected visitEnumField(field: EnumField): (data: any) => React.ReactElement<any> {
        if (field.multiple) {
            return (data: any) => <ul className="wil-icon-list">
                    {field.options.map(o => (
                    <li className={data.indexOf(o.key) === -1 ? "disable" : ""} key={`property-display-${field.id}-option-${o.key}`}>
                        <i className={data.indexOf(o.key) !== -1 ? "icon_box-checked" : "icon_close_alt2"}/> {o.name}
                    </li>
                        ))}
                </ul>
        }
        return (data: any) => <span>{data !== null ? this.capitalize(data.replace(/_/g, ' ')): undefined}</span>
    }

    protected visitImageField(field: ImageField): (data: any) => React.ReactElement<any> {
        return (data: any) => <span>{data}</span>
    }

    protected visitLengthIntervalField(field: LengthIntervalField): (data: any) => React.ReactElement<any> {
        const getValue = (value: number) => {
            if (value >= 1000000) {
                return Math.floor(value / 1000000);
            }
            if (value >= 1000) {
                return Math.floor(value / 1000);
            }
            if (value >= 10) {
                return Math.floor(value / 10);
            }

            return value;
        }
        const getUnit = (value: number) => {
            if (value < 10) {
                return "mm";
            }
            if (value < 1000) {
                return "cm";
            }
            if (value < 1000000) {
                return "m";
            }
            return "km";
        }
        return (data: any) => <span>{getValue(data.min)}{getUnit(data.min)} - {getValue(data.max)}{getUnit(data.max)}</span>
    }

    protected visitTextField(field: TextField): (data: string) => React.ReactElement<any> {
        return (data: string) => <span>{data && data.normalize()}</span>
    }

    protected visitBooleanField(field: BooleanField): (data: any) => React.ReactElement<any> {
        return (data: any) => <span>{data ? "Ja" : "Nee"}</span>
    }

    private capitalize(input: string) {
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    }
}


// WEBPACK FOOTER //
// ./src/factories/PropertyDisplayFactory.tsx